<template>
	<div>
		<form
			class="mt-3"
			ref="mainForm"
			:action="['/api/users/', user.id].join('')"
			method="post"
			axiosMethod="patch">
			<CRow>
				<CCol sm="12">
					<CInput type="text" label="Rôle" :readonly="true" :value="roleMapping[user.role]" />
				</CCol>
			</CRow>
			<CRow>
				<CCol sm="12">
					<CInput type="email" label="E-mail" name="email" :value="user.email" required />
				</CCol>
			</CRow>
			<CRow>
				<CCol sm="12">
					<CInput type="password" label="Mot de passe" name="plainPassword" />
				</CCol>
			</CRow>
			<CRow>
				<CCol sm="12">
					<CInput type="text" label="Code utilisateur" :readonly="true" :value="user.userCode" />
				</CCol>
			</CRow>
			<CRow>
				<CCol sm="12">
					<p>Newsletter</p>
					<GSwitch name="newsletter" color="primary" :checked="user.newsletter" />
				</CCol>
			</CRow>
		</form>
		<CButton class="float-right" color="success" v-on:click="onSubmit($refs.mainForm)"
			>Sauvegarder</CButton
		>
	</div>
</template>

<script>
	import GSwitch from '../../../../components/ghostlexly-components/GSwitch';

	export default {
		components: {
			GSwitch,
		},
		props: {
			user: Object,
		},
		data() {
			return {
				roleMapping: {
					ROLE_CUSTOMER: 'Client',
					ROLE_GUEST: 'Invité',
					ROLE_ADMIN: 'Administrateur',
				},
			};
		},
		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Client modifié avec succès !');
					} else {
						this.$toast.error(res.data['hydra:description']);
					}
				});
			},
		},
	};
</script>

<style scoped></style>
